import cn from 'classnames';
import styles from './loader.module.scss';

export type LoaderProps = {
  className?: string;
};

/**
 * Loader
 * @param className
 */
export const Loader = ({ className }: LoaderProps) => {
  return (
    <div className={cn(styles.loader, className)}>
      <div className={styles.dot}></div>
      <div className={styles.dot}></div>
      <div className={styles.dot}></div>
    </div>
  );
};
